/**
 * Spanish URL routes - all internal links use these.
 * Next.js rewrites map these to the actual folder structure (English paths).
 */
export const routes = {
  home: "/",
  about: "/nosotros",
  contact: "/contacto",
  services: {
    pitches: "/servicios/canchas",
    parquetFutsal5: "/servicios/canchas/parquet-futsal-5",
    syntheticFutsal3: "/servicios/canchas/cesped-sintetico-futsal-3",
    tournaments: "/servicios/torneos",
    birthdays: "/servicios/cumpleanos",
    otherSports: "/servicios/otros-deportes",
    howToGetThere: "/servicios/como-llegar",
  },
  terms: "/terminos-y-condiciones",
  privacy: "/politica-de-privacidad",
  listing: "/reservas",
  payments: {
    success: "/pagos/exito",
    pending: "/pagos/pendiente",
    failed: "/pagos/failure",
  },
  pricing: "/precios",
} as const;
